import { Component, effect, inject, signal } from '@angular/core';
import { Spacer } from '@shared/components/spacer/spacer';
import { OutlineButton } from '@shared/components/outline-button/outline-button';
import { PrimaryButtonComponent } from '@shared/components/primary-button/pirmary-button.component';
import { detectPlatform, PlatformType } from '@shared/utils/platform.util';
import { QRCodeComponent } from 'angularx-qrcode';
import { RegistrationStore } from '@features/registration/store/registration.store';
import { PlusmoreCard } from './_components/plusmore_card/plusmore-card';
import { MatFormField, MatInput, MatLabel } from '@angular/material/input';
import { FormatCardNumberPipe } from '../../../../shared/pipes/format-card-number-pipe';

@Component({
  selector: 'app-registration-success',
  imports: [
    Spacer,
    OutlineButton,
    PrimaryButtonComponent,
    QRCodeComponent,
    PlusmoreCard,
    MatFormField,
    MatLabel,
    MatInput,
    FormatCardNumberPipe,
  ],
  templateUrl: './registration-success.html',
  styleUrl: './registration-success.scss',
})
export class RegistrationSuccess {
  platform = signal<PlatformType>(detectPlatform());
  platformType = PlatformType;
  androidLink = 'https://play.google.com/store/apps/details?id=com.plusmore.app&hl=en_ZA';
  store = inject(RegistrationStore);

  constructor() {
    effect(() => {
      if (this.platform() === PlatformType.android && this.store.cardNumber()) {
        this.androidLink =
          'https://plusmore.co.za/redirect?route=join?cardNumber=' + this.store.cardNumber();
      }
    });
  }
}
